export default {
  path: '/purchasing',
  name: 'purchasing',
  component: () => import('@/layouts/BaseLayout'),
  redirect: '/purchasing/purchase_create',
  children: [
    {
      path: 'purchase_create',
      meta: { title: '采购开单', permission: 'purchase_create' },
      component: () => import('@/views/purchasing/purchaseCreate/index'),
    },
    {
      path: 'purchase_record',
      meta: { title: '采购入库', permission: 'purchase_record' },
      component: () => import('@/views/purchasing/purchaseRecord/index'),
    },
    {
      path: 'purchase_record_detail',
      meta: { 
        title: '采购入库详情', 
        permission: 'purchase_record_detail',
        activeMenu: '/purchasing/purchase_record'  // 添加在这里
      },
      component: () => import('@/views/purchasing/purchaseRecordDetail/index'),
    },
    {
      path: 'purchase_return_create',
      meta: { title: '采购退货', permission: 'purchase_return_create' },
      component: () => import('@/views/purchasing/purchaseReturnCreate/index'),
    },
    {
      path: 'return_record',
      meta: { title: '退货记录', permission: 'return_record' },
      component: () => import('@/views/purchasing/returnRecord/index'),
    },
    {
      path: 'return_record_detail',
      meta: { 
        title: '退货记录详情', 
        permission: 'return_record_detail',
        activeMenu: '/purchasing/return_record'  // 同样为退货记录详情添加
      },
      component: () => import('@/views/purchasing/returnRecordDetail/index'),
    },
  ],
}